import { getFilterEditObj } from '@/stores/slices/filterSlice';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export const useFilterStateSync = () => {
	const params = useParams();
	const isFilterEdit = useSelector(getFilterEditObj);
	const [filtersInitialized, setFiltersInitialized] = useState(false);
	const [editFilterName, setEditFilterName] = useState('');

	// useEffect(() => {
	// 	setEditFilterName(isFilterEdit?.title ?? '');
	// }, [isFilterEdit]);

	useEffect(() => {
		// if (params?.uuid) {
		// 	const timer = setTimeout(() => setFiltersInitialized(true), 500);
		// 	return () => clearTimeout(timer);
		// }
		// setFiltersInitialized(true);
	}, [params]);

	return { filtersInitialized, editFilterName, setEditFilterName };
};
